import { useEffect } from 'react';

import { useRoleShowActions } from './RoleShowContext';

import { getRole } from './restApi';

const RoleShowLoader = ({ role }) => {
  const { initializeState, onResponse, onError } = useRoleShowActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getRole({ role, onResponse, onError });
  }, []);

  return null;
};

export default RoleShowLoader;
